import { SettingsLoaderService } from '@supoui/core/services/settings.loader.service';

export async function initializeAppSettings(loaderService: SettingsLoaderService): Promise<any> {
  return loaderService.loadConfigurations();
}
